import React from "react";
import { TextContentDefinition, StyleVariant } from '../AmorgMenuTypes';
import styled from "styled-components";
import { colorHelper } from "../helpers/colorHelper";

type TextContentProps = TextContentDefinition &
{
    flex:string,
    textAlign:'left'|'right'
    isHovering:boolean
    styleVariant:StyleVariant
}
export function TextContent(props:TextContentProps):JSX.Element
{
    return (
        <StyledLabel
            flex={props.flex}
            textAlign={props.textAlign}
            styleVariant={props.styleVariant}
            isHovering={props.isHovering}>
            
            {props.text}
        </StyledLabel>
    );
}

const StyledLabel = styled.label<{isHovering:boolean,styleVariant:StyleVariant, flex:string, textAlign:'left'|'right'}>`
    text-align:${props => props.textAlign};
    flex:${props => props.flex};
    color:${props => colorHelper.getForegroundColor(props.styleVariant)};
    cursor:${props => props.isHovering ? 'pointer' : 'default'};
    text-decoration:${props => props.styleVariant === 'strike-through' ? 'line-through' : 'none' };
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0.5px;
    line-height: 22px;
`;